import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import RootPage from "../RootPage";
import localisations from "../../shell/localisation";
import MovementAllocationFeature from "../../features/allocations/movement-allocation";
import { useAuth0 } from "@auth0/auth0-react";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";

function MovementAllocationPage() {
    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.movementAllocation.heading}>
            <MovementAllocationFeature fieldCompanyId={fieldCompanyId} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, MovementAllocationPage, "Movement Allocation Page");
